export const money = (n) =>
  `$${Number(n || 0).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

export const STATUS = {
  paid: { label: "Paid", cls: "bg-green-100 text-green-900 border-green-300" },
  partial: { label: "Partly paid", cls: "bg-blue-100 text-blue-900 border-blue-300" },
  unpaid: { label: "Not paid yet", cls: "bg-amber-100 text-amber-900 border-amber-300" },
  no_fee: { label: "No fee due", cls: "bg-stone-100 text-stone-800 border-stone-300" },
};

export function estimateDue(fam, settings = {}, activities = []) {
  const fees = settings.fees || [];
  const byId = Object.fromEntries(fees.map((f) => [f.id, f]));
  let total = 0;
  let tbd = false;
  const add = (fee) => (fee.tbd ? (tbd = true) : (total += Number(fee.amount) || 0));
  fam.members.forEach((m) => { const f = byId[m.fee_id]; if (f && f.per !== "family") add(f); });
  fees.filter((f) => f.per === "family").forEach(add);
  activities.forEach((a) => {
    const s = fam.activity_signups?.[a.id];
    if (s) total += (s.adults || 0) * (Number(a.price_adult) || 0) + (s.keiki || 0) * (Number(a.price_keiki) || 0);
  });
  total += Object.values(fam.shirt_orders || {}).reduce((x, q) => x + (Number(q) || 0), 0) * (Number(settings.shirt_price) || 0);
  return { total, tbd };
}

export const today = () => new Date().toISOString().slice(0, 10);

export const PAY_METHODS = ["Cash", "Check", "Venmo", "Cash App", "Payment link", "Zelle", "PayPal", "Other"];
